import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IResponse } from 'views/ProFormaTable/hooks/useGetProFormaExecutiveSummaryPdf';
import { IExtractedProFormaQueryParams } from './useGetExtractedProForma';

export const getExtractedProFormaExecutiveSummaryPdf = async (
    { organizationId, dealId, extractedProFormaId }: IExtractedProFormaQueryParams,
): Promise<IResponse> => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.EXTRACTED_PRO_FORMA_EXECUTIVE_SUMMARY_PDF(organizationId, dealId, extractedProFormaId),
    );
    return response.data;
};

export default getExtractedProFormaExecutiveSummaryPdf;
